<template lang="pug">
.cadastro-page-header
  h1.cadastro-page-header__title {{ titulo }}
  p.cadastro-page-header__subtitle(v-if="subtitulo") {{ subtitulo }}
</template>

<script>
export default {
  name: 'CadastroPageHeader',
  props: {
    titulo: {
      type: String,
      required: true
    },
    subtitulo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-page-header__title {
  color: #1e174e;
  font-family: 'Poppins', 'Ubuntu', sans-serif;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.15;
  margin: 0 0 8px;
}

.cadastro-page-header__subtitle {
  color: #4c4c4c;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 24px;
}
</style>
